export const homeScreenRoutes = {
  'route.home.index': '/',

  'api.specialty.index': 'specialties',
  'api.search.general': 'search',
};
